import React from "react";
import { Check, MapPin } from "lucide-react";
import { useLang } from "../LangContext";
import { IMAGES } from "../constants";

export default function About() {
  const { t } = useLang();
  return (
    <section
      id="sobre"
      className="py-24 md:py-32 bg-[#F0EDE5]/60 border-y border-[#1e3a5f]/5"
      data-testid="about-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-6 order-2 lg:order-1">
            <div className="flex items-center gap-3 mb-5">
              <span className="h-px w-10 bg-[#7a8b50]" />
              <span className="text-[11px] uppercase tracking-[0.28em] text-[#7a8b50] font-semibold">
                {t.smallLabels.about}
              </span>
            </div>
            <h2 className="font-serif-display text-4xl md:text-5xl text-[#1e3a5f] font-medium tracking-tight leading-tight">
              {t.about.title}
            </h2>
            <p className="mt-6 text-base md:text-lg text-[#1e3a5f]/75 leading-relaxed">{t.about.p1}</p>
            <p className="mt-4 text-base text-[#1e3a5f]/70 leading-relaxed">{t.about.p2}</p>

            <ul className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-4">
              {t.about.bullets.map((b, i) => (
                <li
                  key={i}
                  data-testid={`about-bullet-${i}`}
                  className="flex items-start gap-3 bg-white px-5 py-4 rounded-2xl border border-[#7a8b50]/15"
                >
                  <span className="mt-0.5 h-6 w-6 rounded-full bg-[#7a8b50]/15 flex items-center justify-center shrink-0">
                    <Check className="h-3.5 w-3.5 text-[#7a8b50]" />
                  </span>
                  <span className="text-sm text-[#1e3a5f] font-medium leading-snug">{b}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-6 order-1 lg:order-2 relative">
            <div className="relative aspect-[5/6] rounded-[2rem] overflow-hidden border border-[#7a8b50]/20">
              <img src={IMAGES.about} alt="Munguía, Bizkaia" className="w-full h-full object-cover" />
              <div className="absolute bottom-5 left-5 right-5 bg-white/95 backdrop-blur-md rounded-2xl px-5 py-4 flex items-center gap-3 border border-[#7a8b50]/20">
                <MapPin className="h-5 w-5 text-[#7a8b50]" />
                <div>
                  <div className="text-xs uppercase tracking-[0.2em] text-[#7a8b50] font-semibold">Bizkaia</div>
                  <div className="font-serif-display text-xl text-[#1e3a5f] font-semibold leading-tight">Munguía</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
